<script>
</script>

<div>
  <slot />
</div>

<style>
  div {
    display: flex;
  }

  div > :global(*:not(:first-child)) {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    border-left: 0;
  }

  div > :global(*:not(:last-child)) {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
</style>
